import { useIntl } from 'gatsby-plugin-intl';
import { useMemo } from 'react';

const useGetContactPageTranslation = () => {
  const { formatMessage: t, locale } = useIntl();
  return useMemo(() => {
    if (locale && t) {
      return {
        pageTitle: t({ id: 'pages.contact' }),
        faq: {
          title: t({ id: 'contact.sections.0.title' }),
        },
        formSection: {
          title: t({ id: 'contact.sections.1.title' }),
          descriptions: [
            {
              description: t({
                id: 'contact.sections.1.descriptions.0',
              }),
              isLink: false,
              linkTo: '',
            },
            {
              description: t({
                id: 'contact.sections.1.linkTexts.0',
              }),
              isLink: true,
              linkTo: '/privacy-policy',
            },
            {
              description: t({
                id: 'contact.sections.1.descriptions.1',
              }),
              isLink: false,
              linkTo: '',
            },
          ],
          successMessage: {
            title: t({
              id:
                'contact.sections.1.form.successMessage.title',
            }),
            message: t({
              id:
                'contact.sections.1.form.successMessage.message',
            }),
            buttonText: t({
              id: 'contact.sections.1.form.buttonTexts.1',
            }),
          },
        },
        form: {
          labels: [
            t({ id: 'contact.sections.1.form.pageOne.0' }),
            t({ id: 'contact.sections.1.form.pageOne.1' }),
            t({ id: 'contact.sections.1.form.pageOne.2' }),
          ],
          buttonText: t({
            id: 'contact.sections.1.form.buttonTexts.0',
          }),
        },
      };
    } else {
      return {
        pageTitle: '',
        faq: {
          title: '',
        },
        formSection: {
          title: '',
          descriptions: [],
          successMessage: {
            title: '',
            message: '',
            buttonText: '',
          },
        },
        form: {
          labels: [],
          buttonText: '',
        },
      };
    }
  }, [locale, t]);
};

export default useGetContactPageTranslation;
